export const EQUITY_LIMIT = {
	KFT: 3_000_000,
	ZRT: 5_000_000,
	NYRT: 20_000_000,
};

export const ENTERPRISE_FORMS = ["SELF_EMPLOYED", "SELF_EMPLOYED_KATA", "BT_KATA", "PRIMARY_PRODUCER", "FAMILY_FARM"];

export const TEAOR_AGRAR = [
	"011",
	"012",
	"013",
	"014",
	"015",
	"016",
	"017",
	"02",
	"10",
	"11",
	"12",
	"03",
	"462",
	"463",
	"6820",
];
export const TEAOR_KO = ["254", "304", "920", "64", "65", "66"];
export const TEAOR_TOURIST = [
	"4939",
	"4932",
	"5030",
	"5510",
	"5520",
	"5530",
	"5590",
	"5610",
	"5621",
	"5630",
	"7911",
	"7912",
	"7990",
	"8230",
	"8551",
	"9002",
	"9311",
	"9313",
	"9604",
	"9329",
];

export const COMPANY_KOS = {
	negativeLastClosedBusinessYear:
		"Sajnáljuk, de céged év végi negatív üzemi/adózott eredménye miatt idén nem alkalmas hitelfelvételre.",
	negativeEquity: "Sajnáljuk, de céged negatív saját tőkéje miatt idén nem alkalmas hitelfelvételre.",
	hasOverdueNavDebt: "Sajnáljuk, de céged élő NAV tartozás mellett nem alkalmas hitelfelvételre, rendezned kell.",
	hasOverdueLoanDebt:
		"Sajnáljuk, de céged fennálló lejárt hiteltartozása miatt nem alkalmas újabb hitel felvételére.",
	hasAnotherCompanyUnderLiquidation:
		"Sajnáljuk, de céged tulajdonosi köréhez tartozó felszámolás alatt lévő társaság miatt nem alkalmas hitelfelvételre.",
	hasConnectedCompanyUnderLiquidation:
		"Sajnáljuk, de cégedhez kapcsolódó felszámolás alatt lévő társaság miatt nem alkalmas hitelfelvételre.",
	ownerInKhr:
		"Sajnáljuk, de céged tulajdonosi/vezetői körében lévő KHR/BAR listás státusz miatt nem alkalmas hitelfelvételre.",
	ownerDenied:
		"Sajnáljuk, de céged tulajdonosi/vezetői körében lévő vezetőségtől eltiltott státusz miatt nem alkalmas hitelfelvételre.",
	hadMoreThanHalfOwnerChange:
		"Sajnáljuk, de a fél éven belül történt 50%-nál nagyobb arányú tulajdonosváltás esetében céged induló vállalkozásnak minősül, így nincs elegendő gazdasági múltja ahhoz, hogy hitelképes legyen.",
};

export const ENTERPRISE_KOS = {
	hasNegativeIncomeAfterTaxation:
		"Sajnáljuk, de céged évi végi negatív eredménye miatt nem alkalmas hitelfelvételre.",
	hasOverdueNavDebt: "Sajnáljuk, de céged élő NAV tartozás mellett nem alkalmas hitelfelvételre, rendezned kell.",
	hasOverdueLoanDebt:
		"Sajnáljuk, de céged fennálló lejárt hiteltartozása miatt nem alkalmas újabb hitel felvételére.",
	ownerInKhr: "Sajnáljuk, de a KHR/BAR listás státusz miatt nem alkalmas hitelfelvételre.",
};
